/*eslint @typescript-eslint/no-unused-vars: "off"*/
/* tslint:disable */
/* eslint-disable */
/**
 * Atlas API
 * Atlas API
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @interface QuestionMappingFeedback
 */
export interface QuestionMappingFeedback {
    /**
     * 
     * @type {string}
     * @memberof QuestionMappingFeedback
     */
    company_id: string;
    /**
     * 
     * @type {number}
     * @memberof QuestionMappingFeedback
     */
    question_mapping_pos: number;
    /**
     * Collection of feedback options for question mapping feature.
     * @type {string}
     * @memberof QuestionMappingFeedback
     */
    rating: QuestionMappingFeedbackRatingEnum;
    /**
     * 
     * @type {number}
     * @memberof QuestionMappingFeedback
     */
    response_pos?: number;
    /**
     * 
     * @type {string}
     * @memberof QuestionMappingFeedback
     */
    response_value?: string;
    /**
     * 
     * @type {string}
     * @memberof QuestionMappingFeedback
     */
    source_question_id: string;
    /**
     * 
     * @type {string}
     * @memberof QuestionMappingFeedback
     */
    target_question_id: string;
    /**
     * 
     * @type {string}
     * @memberof QuestionMappingFeedback
     */
    user_id: string;
}




/**
* @export
* @enum {string}
*/
export enum QuestionMappingFeedbackRatingEnum {
    RESPONSEAPPLIED = 'RESPONSE_APPLIED',
    THUMBSDOWN = 'THUMBS_DOWN',
    THUMBSUP = 'THUMBS_UP'
}


